import { Card } from "@/components/panel";

const fmt = (n) => Number(n || 0).toLocaleString("es-AR");

// datos: object {label: n} or array of [label, n]. ocultarCeros hides empty rows of long catalogs.
export const Desglose = ({ titulo, datos = {}, testid, ocultarCeros = false }) => {
  const filas = (Array.isArray(datos) ? datos : Object.entries(datos)).filter(([, n]) => !ocultarCeros || n > 0);
  const total = filas.reduce((a, [, n]) => a + n, 0);
  return (
    <Card data-testid={testid} className="min-w-0">
      <div className="flex items-baseline justify-between mb-3">
        <h3 className="font-heading font-bold text-[var(--brand-primary)]">{titulo}</h3>
        <span className="text-xs text-[var(--brand-text-muted)]" data-testid={`${testid}-total`}>Total {fmt(total)}</span>
      </div>
      {total === 0 ? <p className="text-sm text-[var(--brand-text-muted)]">Todavía no hay datos.</p> : (
        <ul className="space-y-2">
          {filas.map(([k, n], i) => (
            <li key={`${k}-${i}`} className="text-sm">
              <div className="flex justify-between gap-3"><span className="truncate">{k}</span><b data-testid={`${testid}-${k}`}>{fmt(n)}</b></div>
              <div className="h-1.5 rounded-full bg-slate-100 mt-1"><div className="h-1.5 rounded-full bg-[var(--brand-accent)]" style={{ width: `${(n / total) * 100}%` }} /></div>
            </li>
          ))}
        </ul>
      )}
    </Card>
  );
};
